export default __webpack_public_path__ + "static/RoseTico-01194356809bffac66e46042ec0f050c.jpeg";